<template>
  <AdsButton
    v-bind="$attrs"
    :loading="$store.state.isLoading"
    parimary
    button-text="Endorse"
    v-on="$listeners"
  />
</template>

<script>
import {AdsButton} from '@nswdoe/doe-ui-core';

export default {
  name: 'EndorseButton',
  components: {AdsButton}
}
</script>

<style lang="scss" scoped>

</style>
